import {
    DateFormats,
    FormInput,
    Stepper,
    StringHelpers,
    SubTitle,
    useLangContext,
} from 'carrier-fe';
import React from 'react';
import { STEPS } from '../../util/Constants';

const Section = ({ children }: { children: React.ReactNode }) => {
    return <div className="mb-4">{children}</div>;
};

type StageTwoProps = {
    form: any;
    loading: boolean;
    pageLang?: any;
};

function StageTwo({ form, loading,pageLang }: StageTwoProps) {
    const { crud, fields } = useLangContext();
    const { Input } = form;
    return (
        <Stepper.Step
            loading={loading}
            title={pageLang?.page?.steps?.[STEPS.STEP_2 - 1]?.title || ''}
            description={pageLang?.page?.steps?.[STEPS.STEP_2 - 1]?.description ||''}
        >
            <Section>
                <SubTitle
                    title={StringHelpers.title(crud?.sub_titles?.details || 'Details')}
                    className="mb-3 w-100"
                    style={{ color: '#464C5E' }}
                />

                {Input({
                    name: 'serial_number',
                    label: StringHelpers.title(fields?.serial_number || 'Serial Number'),
                    type: 'text',
                    required: true,
                })}

                {Input({
                    name: 'installation_postcode',
                    label: StringHelpers.title(fields?.installation_postcode || 'Installation Postcode'),
                    type: 'text',
                    required: true,
                })}

            </Section>
        </Stepper.Step>
    );
}

export default StageTwo;